import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'CRM_DASHBOARD_UPDATE',
    smsDelete : 'CRM_DASHBOARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {

        stats : [],
        activty : [],
        upcomingWorks : [],
        pipelines : [],
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },
    mutations : {
        ...mutations,


      
        SET_DASHBOARD_STATS (state, data) {
            state.stats = data;
        },
        SET_DASHBOARD_ACTIVITY(state, data) {
            state.activty = data;
        },
        SET_DASHBOARD_UPCOMING_WORKS(state, data) {
            state.upcomingWorks = data;
        },
        SET_DASHBOARD_PIPELINE(state, data) {
            state.pipelines = data;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {

        

        async fetchCRMDashboardStats ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_crm_dashboard_stats, config);
                let response = result.data.data
              
                commit('SET_DASHBOARD_STATS', response);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async fetchCRMDashboardActivity ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_crm_dashboard_today_activity, config);
                let response = result.data.data
              
                commit('SET_DASHBOARD_ACTIVITY', response);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },
         async fetchCRMDashboardUpcomingWork ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_crm_dashboard_upcoming_work, config);
                let response = result.data.data
              
                commit('SET_DASHBOARD_UPCOMING_WORKS', response);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async fetchCRMDashboardPipeline ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_crm_dashboard_pipeline, config);
                let response = result.data.data
              
                commit('SET_DASHBOARD_PIPELINE', response);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        

        

        


  
    },

    getters: {}
}
